import { render, staticRenderFns } from "./post_list_hoax.vue?vue&type=template&id=2e0fe98c&scoped=true"
import script from "./post_list_hoax.vue?vue&type=script&lang=js"
export * from "./post_list_hoax.vue?vue&type=script&lang=js"
import style0 from "./post_list_hoax.vue?vue&type=style&index=0&id=2e0fe98c&prod&lang=css"
import style1 from "./post_list_hoax.vue?vue&type=style&index=1&id=2e0fe98c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0fe98c",
  null
  
)

export default component.exports